
export default {
  setUser (state, data) {
    state.user = data
  },
  setUserInfo (state, data) {
    state.UserInfo = data
  },
  // setPinkey (state, data) {
  //   state.pinkey = data
  // },
  // setMd5key (state, data) {
  //   state.md5key = data
  // },
  setTimestamp (state) {
    state.timestamp = new Date().getTime()
  },
  setUserId (state, data) {
    state.userId = data
  },
  setUserName (state, data) {
    state.userName = data
  },
  setPrivileges (state, data) {
    state.privileges = data
  },
  setBreadcrumb (state, data) {
    state.breadcrumbContent = data
  },
  setLoadCount (state, data) {
    data ? state.needLoadingRequestCount++ : state.needLoadingRequestCount === 0 ? state.needLoadingRequestCount = 0 : state.needLoadingRequestCount--
  },
  setDepartmentTree (state, data) {
    state.departmentTree = data
  },
  setAreaTree (state, data) {
    state.AreaTree = data
  },
  setPersonList (state, personList) {
    state.personList = personList
  },
  setSysParameterList (state, sysParameterList) {
    state.sysParameterList = sysParameterList
  },
  setInstitutionList (state, data) {
    state.institutionList = data
  },
  setUserList (state, data) {
    state.userList = data
  },
  setRoleList (state, data) {
    state.roleList = data
  },
  setDeviceList (state, data) {
    state.deviceList = data
  },
  setCommPassSettingList (state, data) {
    state.commPassSettingList = data
  },
  setRuleList (state, data) {
    state.ruleList = data
  },
  setDoorOpenList (state, data) {
    state.doorOpenList = data
  },
  setDoorList (state, data) {
    state.doorList = data
  },
  setHolidayList (state, data) {
    state.holidayList = data
  },
  setTempPassSettingList (state, data) {
    state.tempPassSettingList = data
  },
  setRuleId (state, data) {
    state.ruleId = data
  },
  setMenuList (state, data) {
    state.menuList = data
  },
  setHandleType (state, data) {
    state.ruleId = data
  },
  setDepartmentList (state, data) {
    state.departmentList = data
  },
  setPersonTypeList (state, data) {
    state.personTypeList = data
  },
  setStaffTypeList (state, data) {
    state.staffTypeList = data
  },
  setPassTypeList (state, data) {
    state.passTypeList = data
  },
  setDeviceTypeList (state, data) {
    state.deviceTypeList = data
  },
  setOpenModeList (state, data) {
    state.openModeList = data
  },
  setWarnTypeList (state, data) {
    state.warnTypeList = data
  },
  setCertTypeList (state, data) {
    state.certTypeList = data
  },
  setChooseDeviceList (state, data) {
    state.chooseDeviceList = data
  },
  clearPullDownList (state) {
    state.departmentList.length = 0
    state.personTypeList.length = 0
    state.staffTypeList.length = 0
    state.passTypeList.length = 0
    state.deviceTypeList.length = 0
    state.openModeList.length = 0
    state.warnTypeList.length = 0
    state.certTypeList.length = 0
    state.chooseDeviceList.length = 0
  },
  clearPermission (state) {
    state.SystemPermission.isCheck = false
    state.InstitutionPermission.isCheck = false
    state.departmentPermission.isCheck = false
    state.UserPermission.isCheck = false
    state.RolePermission.isCheck = false
    state.LogPermission.isCheck = false
    state.deviceAreaPermission.isCheck = false
    state.personPermission.isCheck = false
    state.devicePermission.isCheck = false
    state.doorPermission.isCheck = false
    state.PassRulePermission.isCheck = false
    state.CommPassSettingPermission.isCheck = false
    state.TempPassSettingPermission.isCheck = false
    state.PassHistoryPermission.isCheck = false
    state.RealTimePassPermission.isCheck = false
  },
  setSystemPermission (state, data) {
    data.isCheck = true
    state.SystemPermission = data
  },
  setInstitutionPermission (state, data) {
    data.isCheck = true
    state.InstitutionPermission = data
  },
  setDepartmentPermission (state, data) {
    data.isCheck = true
    state.departmentPermission = data
  },
  setUserPermission (state, data) {
    data.isCheck = true
    state.UserPermission = data
  },
  setLogPermission (state, data) {
    data.isCheck = true
    state.LogPermission = data
  },
  setRolePermission (state, data) {
    data.isCheck = true
    state.RolePermission = data
  },
  setDeviceAreaPermission (state, data) {
    data.isCheck = true
    state.deviceAreaPermission = data
  },
  setPersonPermission (state, data) {
    data.isCheck = true
    state.personPermission = data
  },
  setDevicePermission (state, data) {
    data.isCheck = true
    state.devicePermission = data
  },
  setDoorPermission (state, data) {
    data.isCheck = true
    state.doorPermission = data
  },
  setPassRulePermission (state, data) {
    data.isCheck = true
    state.PassRulePermission = data
  },
  setCommPassSettingPermission (state, data) {
    data.isCheck = true
    state.CommPassSettingPermission = data
  },
  setTempPassSettingPermission (state, data) {
    data.isCheck = true
    state.TempPassSettingPermission = data
  },
  setHolidayPermission (state, data) {
    data.isCheck = true
    state.holidayPermission = data
  },
  setPassHistoryPermission (state, data) {
    data.isCheck = true
    state.PassHistoryPermission = data
  },
  setRealTimePassPermission (state, data) {
    data.isCheck = true
    state.RealTimePassPermission = data
  },
  setGroupOption (state, data) {
    data.isSet = true
    state.groupOption = data
  },
  setHideError (state, data) {
    state.hideError = data
  }
}



// WEBPACK FOOTER //
// ./src/store/door_module/mutations.js